import appInsights from '@/app/components/AppInsights';

type WsPhase = 'main-audio' | 'vad-test';
type WsEvent = 'Attempt' | 'Open' | 'Close' | 'Error';

const host = (url: string) => {
  try {
    return new URL(url).host;
  } catch {
    return 'invalid-url';
  }
};

const ms = () => (typeof performance?.now === 'function' ? performance.now() : Date.now());

export const wsClock = () => ({ start: ms(), openAt: undefined as number | undefined });

export const trackWs = (
  event: WsEvent,
  phase: WsPhase,
  url: string,
  clock: { start: number; openAt?: number },
  extra: Record<string, string | number | boolean | undefined> = {}
) => {
  const now = ms();
  const classification =
    event === 'Close' && extra.intentional
      ? 'intentional-close'
      : clock.openAt == null
        ? 'never-opened'
        : 'opened-then-dropped';
  appInsights.trackEvent({
    name: `VadWebSocket${event}`,
    properties: { phase, host: host(url), classification, ...extra },
    measurements: {
      timeToOpenMs: clock.openAt == null ? undefined : Math.round(clock.openAt - clock.start),
      timeSinceStartMs: Math.round(now - clock.start),
      timeFromOpenMs: clock.openAt == null ? undefined : Math.round(now - clock.openAt)
    }
  });
};

export { ms as nowMs };
